import watchUtils = require("esri/core/watchUtils");
import MapImageLayer = require("esri/layers/MapImageLayer");
import * as layerSource from "./layerSource";
import FeatureLayer = require("esri/layers/FeatureLayer");
import GroupLayer = require('esri/layers/GroupLayer');
import FieldsContent = require('esri/popup/content/FieldsContent');
import AttachmentsContent = require('esri/popup/content/AttachmentsContent');
import Content = require('esri/popup/content/Content');
import PopupTemplate = require("esri/PopupTemplate");

const adtLayer = new MapImageLayer({
    url: layerSource.serverUrl,
    listMode: 'hide-children',
    visible: false,
    legendEnabled: false,
    minScale: 250000,
    sublayers: [
        {
            id: layerSource.AnnualAverageDailyTraffic,
            legendEnabled: false,
        }
    ]
});

const hcvLayer = new MapImageLayer({
    url: layerSource.serverUrl,
    listMode: 'hide-children',
    visible: false,
    legendEnabled: false,
    minScale: 250000,
    sublayers: [
        {
            id: layerSource.HCVLayer,
            legendEnabled: false,
        }
    ]
});

const suLayer = new MapImageLayer({
    url: layerSource.serverUrl,
    listMode: 'hide-children',
    visible: false,
    legendEnabled: false,
    minScale: 250000,
    sublayers: [
        {
            id: layerSource.SULayer,
            legendEnabled: false
        }
    ]
});

const muLayer = new MapImageLayer({
    url: layerSource.serverUrl,
    listMode: 'hide-children',
    visible: false,
    legendEnabled: false,
    minScale: 250000,
    sublayers: [
        {
            id: layerSource.MULayer,
            legendEnabled: false
        }
    ]
});

const popupContent:Content[] = [
    new FieldsContent({
        fieldInfos: [
            {
              fieldName: "Int_nbr",
              label: "Site Code"
            },
            {
              fieldName: "Consultant"
            },
            {
              fieldName: "Comments",
            }
          ]
        }),
    new AttachmentsContent({
        displayType: "list"
    })
    ];
  

export const tmdLayerPopupTemplate = new PopupTemplate({
    // autocasts as new PopupTemplate()
    title: "Turning Movement Data",
    content: popupContent
  });

const tmdLayer = new FeatureLayer({
    url: layerSource.serverUrl,
    layerId: layerSource.TurningMovementDataLayer,
    popupEnabled: true,
    popupTemplate: tmdLayerPopupTemplate,
    visible: false,
    minScale: 250000,
});

export const trafficCountGroupLayer = new GroupLayer({
    title: "Traffic Count",
    id: "10 - Traffic Count",
    visible: true,
    visibilityMode: "independent",
    layers: [
        tmdLayer, muLayer, suLayer, hcvLayer, adtLayer
    ],
});

trafficCountGroupLayer.layers.forEach(layer => {
    watchUtils.whenTrueOnce(layer, "loaded", () => {
      if (layer instanceof MapImageLayer) {
        layer.loadAll().then(() => {
          if (layer.sublayers.length === 1) {
            if (layer.sublayers.getItemAt(0).sourceJSON != null) {
                layer.title = layer.sublayers.getItemAt(0).sourceJSON.name;
                layer.sublayers.getItemAt(0).title = layer.sublayers.getItemAt(0).sourceJSON.name;
            } else {
                layer.title = "Traffic Count Layer";
            }
          } 
          // BuildPopups.buildPopupIfLoaded(layer as MapImageLayer);
        });
      } else {
        layer.title = (layer as FeatureLayer).sourceJSON.name;          
      }
    });
  });
  